if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      if (!this.closest('.language-selector')) return;

      const input = this.querySelector('input[name="language_code"], input[name="country_code"]'),
            btn   = this.querySelector('button'),
            panel = this.querySelector('ul');

      if (!btn || !panel) return;

      const searchLi = document.createElement("li");
      searchLi.className = "localization-search-wrapper";
      searchLi.innerHTML = `<input type="text" placeholder="Search country..." class="localization-search">`;

      panel.insertBefore(searchLi, panel.firstChild);

      const searchInput = searchLi.querySelector(".localization-search");

      btn.addEventListener('click', () => {
        btn.focus();
        panel.toggleAttribute('hidden');
        btn.setAttribute('aria-expanded', (btn.getAttribute('aria-expanded') === 'false').toString());
      });

      btn.addEventListener('focusout', e => {
        if (!e.relatedTarget || e.relatedTarget.nodeName === 'BUTTON') {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', true);
        }
      });

      this.addEventListener('keyup', e => {
        if (e.code.toUpperCase() === 'ESCAPE') {
          btn.setAttribute('aria-expanded', 'false');
          panel.setAttribute('hidden', true);
          btn.focus();
        }
      });

      searchInput.addEventListener("input", () => {
        const filter = searchInput.value.toLowerCase();
        panel.querySelectorAll("li:not(.localization-search-wrapper)").forEach(li => {
          li.style.display = li.textContent.toLowerCase().includes(filter) ? "" : "none";
        });
      });

      this.querySelectorAll('a').forEach(a =>
        a.addEventListener('click', e => {
          e.preventDefault();
          const form = this.querySelector('form');
          input.value = a.dataset.value;
          if (form) form.submit();
        })
      );
    }
  }
  customElements.define('localization-form', LocalizationForm);
}
